import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import '../styles/Webdesign.css';

import aboutVideo from '../assets/vid10.mp4';
import about1 from '../assets/cs5.jpg';
import about2 from '../assets/cs10.avif';
import about3 from '../assets/cs3.jpg';
import about4 from '../assets/cs2.jpg';
import about5 from '../assets/cs11.avif';

import 'swiper/css';
import 'swiper/css/effect-cube';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCube, Pagination, Autoplay } from 'swiper/modules';

const Webdesign = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="webdesign-container">
      <video className="background-video" autoPlay muted loop playsInline>
        <source src={aboutVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="webdesign-content">
        <motion.div
          className="webdesign-left"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1>Web Design</h1>
          <p>
            Our web design team crafts elegant, functional, and responsive digital experiences.
            We focus on usability, visual aesthetics, and performance to deliver engaging websites.
          </p>
        </motion.div>

        <motion.div
          className="webdesign-right"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <div className="swiper-large-wrapper">
            <Swiper
              effect="cube"
              grabCursor
              loop
              autoplay={{ delay: 2500, disableOnInteraction: false }}
              cubeEffect={{
                shadow: true,
                slideShadows: true,
                shadowOffset: 20,
                shadowScale: 0.94,
              }}
              pagination={{ clickable: true }}
              modules={[EffectCube, Pagination, Autoplay]}
              className="mySwiper"
            >
              <SwiperSlide>
                <img src={about1} alt="Slide 1" />
              </SwiperSlide>
              <SwiperSlide>
                <img src={about2} alt="Slide 2" />
              </SwiperSlide>
              <SwiperSlide>
                <img src={about3} alt="Slide 3" />
              </SwiperSlide>
              <SwiperSlide>
                <img src={about4} alt="Slide 4" />
              </SwiperSlide>
              <SwiperSlide>
                <img src={about5} alt="Slide 5" />
              </SwiperSlide>
            </Swiper>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Webdesign;
